import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import CarrierHeader from '../../components/CarrierHeader';
import api from "../../utils/axiosInstance";

const DriverDetail = () => {
    const { state } = useLocation();
    const { id } = useParams();
    const navigate = useNavigate();

    const [driver, setDriver] = useState(state?.driver || null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [resume, setResume] = useState(null); // 🔹 New state for resume

    // Fallback: fetch driver if not passed from state
    useEffect(() => {
        if (!driver && id) {
            api.get(`/drivers/${id}`)
                .then(res => setDriver(res.data))
                .catch(err => console.error('Failed to fetch driver:', err));
        }
    }, [driver, id]);

    // Fetch resume when driver is available
    useEffect(() => {
        if (driver?._id) {
            api.get(`/resumes/latest/${driver._id}`)
                .then((res) => {
                    if (res.data.success && res.data.resume) {
                        setResume(res.data.resume);
                    } else {
                        setResume(null);
                    }
                })
                .catch((err) => {
                    console.error('Error fetching resume:', err.message);
                });
        }
    }, [driver]);

    const openModal = () => setModalOpen(true);
    const closeModal = () => setModalOpen(false);

    const confirmAddDriver = async () => {
        try {
            const carrier = JSON.parse(localStorage.getItem('carrierUser'));
            await api.post('/interests', {
                carrierId: carrier._id,
                driverId: driver._id
            });
            closeModal();
            navigate('/carrier/assigned-drivers');
        } catch (err) {
            console.error('Interest save failed:', err);
        }
    };

    if (!driver) {
        return <div className="text-center mt-20 text-gray-500">Loading driver details...</div>;
    }

    return (
        <div className="bg-gray-100 text-dark min-h-screen lg:pl-64">
            <CarrierHeader />
            <div className="bg-gradient-to-br from-white to-gray-100 rounded-2xl p-5 shadow-xl hover:-translate-y-1 transition duration-300">
                <div className="flex items-center gap-4 mb-5 pb-4 border-b-2 border-[#3c9bf9]">
                    <div>
                        <h2 className="text-xl font-semibold text-gray-900">{driver.name}</h2>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {[
                        ['Route Type:', Array.isArray(driver.route) ? driver.route.join(', ') : driver.route || 'N/A'],
                        ['Job Type:', driver.job || 'N/A'],
                        ['Trailer Type:', Array.isArray(driver.trailer) ? driver.trailer.join(', ') : driver.trailer || 'N/A'],
                        ['CDL Type:', driver.cdl || 'N/A'],
                        ['Endorsements:', Array.isArray(driver.endorsements) ? driver.endorsements.join(', ') : driver.endorsements || 'N/A'],
                        ['Contact:', driver.phone || 'N/A'],
                        ['Location:', `${driver.city || ''}, ${driver.state || ''}`],
                        ['Address:', driver.address || 'N/A']
                    ].map(([label, value], index) => (
                        <div
                            key={index}
                            className="flex items-center p-3 bg-[#3c9bf9]/5 rounded-lg hover:bg-[#3c9bf9]/10 transition duration-300"
                        >
                            <span className="w-32 font-semibold text-[#3c9bf9] text-sm">{label}</span>
                            <span className="text-gray-900 text-sm">{value}</span>
                        </div>
                    ))}
                </div>


                {/* 🔽 Resume Section */}
                <div className="mt-6">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Resume</h3>
                    {resume ? (
                        <a
                            href={`${process.env.REACT_APP_IMAGE_BASE_URL}/${resume.resume.replace(/\\/g, '/')}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-blue-600 hover:bg-black text-white px-4 py-2 rounded text-sm"
                        >
                            View Resume
                        </a>
                    ) : (
                        <button
                            disabled
                            className="bg-black text-white px-4 py-2 rounded text-sm cursor-not-allowed"
                        >
                            No Resume Uploaded
                        </button>
                    )}
                </div>

                <div className="mt-5">
                    <button
                        className="bg-[#3c9bf9] text-white px-6 py-3 rounded-full font-semibold flex items-center gap-2 hover:bg-blue hover:-translate-y-0.5 hover:shadow-lg transition duration-300"
                        onClick={openModal}
                    >
                        <i className="fas fa-star" /> Add Favorite
                    </button>
                </div>
            </div>

            {/* Modal */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full text-center">
                        <h2 className="text-xl font-semibold mb-4 text-gray-800">
                            Would you like to add this Driver?
                        </h2>
                        <div className="flex justify-center gap-4">
                            <button onClick={closeModal} className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded">
                                Cancel
                            </button>
                            <button onClick={confirmAddDriver} className="bg-[#3c9bf9] hover:bg-black text-white px-4 py-2 rounded">
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default DriverDetail;
